import script from "./bestSellingStar.vue?vue&type=script&setup=true&lang=js"
export * from "./bestSellingStar.vue?vue&type=script&setup=true&lang=js"

import "./bestSellingStar.css?vue&type=style&index=0&id=63e9d3c4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e9d3c4"]])

export default __exports__